import React, { FunctionComponent } from 'react';
import clsx from 'clsx';
import { IconActionCheck } from '../../icons';
import { DivPropsWithoutRef } from '../../common/types';
import { Icon } from '../Icon';
import { IconSize } from '../Icon/iconSize';
import { IconIndeterminate } from './IconIndeterminate';

export interface BaseCheckboxIconProps extends DivPropsWithoutRef {
  /**
   * Состояние Checkbox: включен или выключен
   */
  checked?: boolean;
  /**
   * Состояние неопределенного Checkbox. Может использоваться во вложенных Checkbox для визуального отображение состояния родительского Checkbox, когда выбран хотя бы один дочерний Checkbox, но не все.
   */
  indeterminate?: boolean;
  /**
   * Неактивное состояние Checkbox - состояние, при котором компонент отображается, но недоступен для действий пользователя
   */
  inactive?: boolean;
  /**
   * Свойство, устанавливающие тип radio для BaseCheckboxIcon
   */
  radio?: boolean;
  /**
   * Состояния фокуса на компоненте Checkbox
   */
  focused?: boolean;
}

/**
 * @deprecated используйте BaseCheckboxIconProps
 */
export type IBaseCheckboxIconProps = BaseCheckboxIconProps;

export const BaseCheckboxIcon: FunctionComponent<BaseCheckboxIconProps> = ({
  className,
  checked,
  indeterminate,
  inactive,
  radio,
  focused,
  children,
  ...props
}) => {
  return (
    <div
      className={clsx('hse-BaseCheckboxIcon', className, {
        'hse-BaseCheckboxIcon_radio': radio,
        'hse-BaseCheckboxIcon_inactive': inactive,
        'hse-BaseCheckboxIcon_checked': checked || (indeterminate && !radio),
        'hse-BaseCheckboxIcon_focused': focused
      })}
      {...props}
    >
      <div
        className={clsx('hse-BaseCheckboxIcon__icon', {
          'hse-BaseCheckboxIcon__icon_inactive': inactive,
          'hse-BaseCheckboxIcon__icon_visible': checked || indeterminate
        })}
      >
        {!radio
          ? children || (
              <Icon
                size={IconSize.small}
                icon={indeterminate ? IconIndeterminate : IconActionCheck}
              />
            )
          : null}
      </div>
    </div>
  );
};
